import React from 'react';
import { Badge } from '@/components/ui/badge';

export function PRViewContent({ pr }) {
  if (!pr) return null;
  
  var statusClass = pr.status === 'approved' ? 'bg-green-100 text-green-800' : pr.status === 'rejected' ? 'bg-red-100 text-red-800' : 'bg-amber-100 text-amber-800';
  
  return React.createElement('div', { className: 'space-y-4 py-4' },
    React.createElement('div', { className: 'grid grid-cols-2 gap-4 text-sm' },
      React.createElement('div', null, 'GRN: ', React.createElement('strong', null, pr.grn_number)),
      React.createElement('div', null, 'Supplier: ', React.createElement('strong', null, pr.supplier_name)),
      React.createElement('div', null, 'Type: ', React.createElement(Badge, { variant: 'outline' }, pr.return_type)),
      React.createElement('div', null, 'Status: ', React.createElement(Badge, { className: statusClass }, (pr.status || '').toUpperCase())),
      React.createElement('div', null, 'Total: ', React.createElement('strong', { className: 'text-red-700' }, '₹', pr.total_return_value)),
      React.createElement('div', null, 'Created: ', pr.created_at ? pr.created_at.split('T')[0] : '')),
    React.createElement(PRItemsTable, { items: pr.items }),
    pr.approval_history && pr.approval_history.length > 0 && React.createElement(PRApprovalHistory, { history: pr.approval_history }));
}

function PRItemsTable({ items }) {
  return React.createElement('div', { className: 'border rounded-lg overflow-hidden' },
    React.createElement('table', { className: 'w-full text-sm' },
      React.createElement('thead', { className: 'bg-red-50' },
        React.createElement('tr', null,
          React.createElement('th', { className: 'px-3 py-2 text-left' }, 'Product'),
          React.createElement('th', { className: 'px-3 py-2 text-center' }, 'Qty'),
          React.createElement('th', { className: 'px-3 py-2 text-center' }, 'Reason'),
          React.createElement('th', { className: 'px-3 py-2 text-right' }, 'Value'))),
      React.createElement('tbody', { className: 'divide-y' },
        (items || []).map(function(item, idx) {
          return React.createElement('tr', { key: idx },
            React.createElement('td', { className: 'px-3 py-2' }, item.product_name),
            React.createElement('td', { className: 'px-3 py-2 text-center font-semibold' }, item.return_quantity),
            React.createElement('td', { className: 'px-3 py-2 text-center' }, React.createElement(Badge, { variant: 'outline', className: 'text-xs' }, item.reason)),
            React.createElement('td', { className: 'px-3 py-2 text-right font-mono' }, '₹', item.line_total));
        }))));
}

function PRApprovalHistory({ history }) {
  return React.createElement('div', null,
    React.createElement('p', { className: 'text-xs text-gray-500 font-medium mb-1' }, 'Approval History'),
    React.createElement('div', { className: 'space-y-1' },
      history.map(function(h, i) {
        return React.createElement('div', { key: i, className: 'flex items-center gap-2 text-xs text-gray-600' },
          React.createElement(Badge, { variant: 'outline', className: 'text-xs' }, h.action),
          React.createElement('span', null, h.by_name),
          React.createElement('span', { className: 'text-gray-400' }, h.timestamp ? h.timestamp.split('T')[0] : ''));
      })));
}
